export function removeSessionItem (key: string): void {
  window.sessionStorage.removeItem(key)
}

/**
 * retrieve object from sessionStorage
 * @returns {null}
 */
export function getSessionItem (key: string): any {
  if (window) {
    const str = window.sessionStorage.getItem(key)
    if (str) {
      try {
        return JSON.parse(str)
      } catch (error) {
        console.warn('19', 'getLocalItem', 'getLocalItem', error)
      }
    }
  }
}

/**
 * save object to sessionStorage
 * @param object
 */
export function setSessionItem (key: string, object: any): void {
  if (window) {
    window.sessionStorage.setItem(key, JSON.stringify(object))
  }
}
